import { Component, Input } from '@angular/core';
import {DatePipe} from "@angular/common";
import { Biller } from '../../models/billermodel';
import { Account } from '../../models/accountmodel';
import { BillerUpdate } from '../../models/updatebillermodel';
import { billerService }   from '../../services/biller.service';
import { SharedService }   from '../../services/sharedservices.service';
import { Session } from '../../models/sessionmodel';
import { AcctResponse } from '../../models/accountresponse';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import {Router} from  '@angular/router';
import { CurrencyPipe } from '@angular/common';
import { accountService } from 'services/account.service';

@Component({
  templateUrl: './biller.component.html',
  styleUrls: ['../../css/sb-admin.min.css'],
  providers: [billerService]
})

export class BillerComponent {
  @Input() responseObj: Session;
  public billers: Biller[];
  public biller: Biller;
  public billerUpdate: BillerUpdate;
  public data;
  errorMessage: string;
  public itemResource;
  public acctresp : AcctResponse;
  items = [];
  itemCount = 0;
  public filterQuery = "";
  public rowsOnPage = 10;
  public sortBy = "storeid";
  public sortOrder = "asc";

 

  constructor(public _billerService: billerService, public router: Router, public sharedservice: SharedService) {    
  }

  ngOnInit()
  {   
      // call the method on initial load of page to bind dropdown      
      this.biller = new Biller();        
      this.billerUpdate =  new BillerUpdate();   
      this.getBillers();      
  }

  postBiller(isValid: boolean){
    if(isValid){
      this._billerService.postBiller(this.biller).subscribe(res => this.handlePostResponse(res), error => this.errorMessage = <any>error);
      this.getBillers();
    }
  }

 updateBiller(isValid: boolean){
    if(isValid){      
      this._billerService.updateBiller(this.billerUpdate).subscribe(res => res, error => this.errorMessage = <any>error);      
      this.getBillers();
    }
  }

  //Get the list of billers
  getBillers() {
      this._billerService.getBillers().subscribe(res => this.handleResponse(res), error => this.errorMessage = <any>error);
  }

   //Get the list of accounts
  retrieveBiller(billerId) {     
      var biller = this.billers.find(a => a.id == billerId);
      this.billerUpdate.updateid = biller.id;     
      this.billerUpdate.updatebillername = biller.billername;
      this.billerUpdate.updaterate = biller.rate;
   }


  handleResponse(result){
    //console.log('users - ' + JSON.stringify(result));
    this.billers = result;  
    this.data  = result;  
    
  }

  handlePostResponse(result){
    this.acctresp = result;
  }

}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/app/biller/biller.component.ts